exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--HistoryOrder--padding:.2564rem}", ""]);

// exports
